import { defineMessages } from 'react-intl'

export default defineMessages({
  start_meal_plan: {
    id: 'start_meal_plan',
    defaultMessage: 'Start Meal Plan',
  },
  learn_more: {
    id: 'Read_more',
    defaultMessage: 'Read more\n',
  },
  how_it_works: {
    id: 'gift_card_how_it_works',
    defaultMessage: 'How it works',
  },
  faq_heading: {
    id: 'faq.heading',
    defaultMessage: 'Common questions',
  },
})
